import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { GET_LINKED_EMPLOYEES } from './useLinkedEmployees.query';
import { GET_AUTOMATICALLY_SEARCHED_ACCOUNTS_QUERY_KEY } from './useSearchedAccounts.query';

interface Props {
  linkedEmployeeIds?: string[];
  primaryEmployeeId?: string;
}

const useLinkAccountQuery = (
  editableEmployeeId: string,
  onSuccess: () => void,
  onError: (error: string) => void
) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, isSuccess } = useMutation(
    async (props: Props) =>
      api.patch(API_URL.EMPLOYEES_LINK_BY_EMPLOYEE_ID(props?.primaryEmployeeId || editableEmployeeId), [
        ...(props?.linkedEmployeeIds?.length ? props.linkedEmployeeIds : []),
      ]),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_AUTOMATICALLY_SEARCHED_ACCOUNTS_QUERY_KEY],
        });
        queryClient.invalidateQueries({
          queryKey: [GET_LINKED_EMPLOYEES],
        });
        onSuccess();
      },
      /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
      onError: (error: any) => {
        onError(error?.response?.data?.elevate_error_message);
      },
    }
  );

  return {
    linkAccount: mutateAsync,
    isLoading,
    isSuccess,
  };
};

export default useLinkAccountQuery;
